import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 px-5 pb-2 page-fill" }
const _hoisted_2 = { class: "items-center justify-between flex ResponsiveStartAudit" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_5 = { class: "table-section" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "My Tasks")
      ], -1)),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: _normalizeClass([_ctx.tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton', "flex"]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.tableRow.length == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          _cache[1] || (_cache[1] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-5 ResponsiveStartAudit" }, [
      _createElementVNode("p", { class: "headerText" }, " My Tasks acts as your individual to-do list and automatically gathers tasks assigned to you across all Audits, enabling you to see and organize your work in one centralized place. ")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_tableData, {
        class: "flex-1 min-h-0",
        tableRowData: _ctx.tableRow,
        headersData: _ctx.mainHeaders,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}